import {
    MapOptions
} from "esdm-map/dist";
import { KentBaseLayerTypes } from "./KentBaseMapping_27700";

export class DefaultMapOptions {

    public static GetDefaultOptions(
        mapElementId: string,
        mapStoreKey: string
    ): MapOptions {       

        let opt = new MapOptions();       
        opt.bingApiKey = $(`#${mapElementId}`).data("bing-api-key");
        opt.esdmOsmApiKey = $(`#${mapElementId}`).data("esdm-osm-api-key");
        opt.baseMaps = [
            KentBaseLayerTypes.KentOS,
            KentBaseLayerTypes.KentAerial2016,
            KentBaseLayerTypes.KentAerial2008,
            KentBaseLayerTypes.KentAerial1990,
            KentBaseLayerTypes.KentAerial1946,
            KentBaseLayerTypes.KentEpoch1,
            KentBaseLayerTypes.KentEpoch2,
            KentBaseLayerTypes.KentEpoch3,
            KentBaseLayerTypes.KentEpoch4
        ];
        opt.defaultBaseMap = KentBaseLayerTypes.KentOS;
        opt.enableBoundsTracking = true;
        opt.zoomToNearestBounds = false;
        opt.maxZoomToBounds = 12;
        opt.mapElementId = mapElementId;
        opt.mapStoreKey = mapStoreKey;
        opt.mapZoom = 7;
        opt.minZoom = 5;
        opt.maxZoom = 16;
        
        opt.extent = [479995,95785,676565,230215];
        opt.mapCentre = [            
                591525,147225
        ];    

        opt.displayProjection = "EPSG:27700";
        opt.dataProjection = "EPSG:27700";
        opt.dragRotateAndZoom = false;                
        return opt;
    }

}
